import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FormSelect as SemanticFormSelect } from "semantic-ui-react";
import PropTypes from "prop-types";
import _ from "lodash";
import { observer } from "mobx-react";
import NestStore from "~/stores/NestStore";
import FormHelper from "~/utils/FormHelper";

@observer
class FormSelect extends Component {
  handleOnChangeSelect = (e, data) => {
    const { dataStore } = this.props;
    _.set(dataStore, data.name, FormHelper.convertToValue(data.value));
    const error = _.get(dataStore.errorMessages, data.name, undefined);
    if (error) {
      _.unset(dataStore.errorMessages, data.name);
    }
  };

  updateOptions() {
    const { defaultValue, options, t } = this.props;
    if (defaultValue !== undefined) {
      const castedDefaultValue = FormHelper.convertToString(defaultValue);
      const defaultExists = options.some(option => option.key === "--null--");
      if (defaultExists) return options;
      const optionFounded = options.some(option => {
        if (option.value === castedDefaultValue) {
          options.unshift({
            key: "--null--",
            value: "--null--",
            text: t("useDefaultWithValue", { defaultValue: option.text }),
          });
          return true;
        }
        return false;
      });
      if (!optionFounded) {
        options.unshift({
          key: "--null--",
          value: "--null--",
          text: t("useDefaultWithValue", { defaultValue: castedDefaultValue }),
        });
      }
    }
    return options;
  }

  render() {
    const { dataStore, defaultValue, name, options, onChange, t, tReady, ...props } = this.props;
    const updatedOptions = defaultValue !== undefined ? this.updateOptions() : options;
    let value = _.get(dataStore, name, null);
    value = defaultValue !== undefined ? FormHelper.convertToString(value) : value;
    const error = _.get(dataStore.errorMessages, name, undefined);
    return (
      <SemanticFormSelect
        value={value}
        options={updatedOptions}
        name={name}
        error={error}
        onChange={onChange || this.handleOnChangeSelect}
        {...props}
      />
    );
  }
}
FormSelect.propTypes = {
  ...SemanticFormSelect.propTypes,
  defaultValue: PropTypes.any,
  dataStore: PropTypes.instanceOf(NestStore).isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(FormSelect);
